import classNames from "classnames";
import { CSSProperties, RefObject } from "react";

import css from "./horizontal_scrollbar.module.scss";
import { useHorizontalScrollbar } from "./use_horizontal_scrollbar";

type HorizontalScrollbarProps = {
  scrollableContainerRef: RefObject<HTMLDivElement | null>;
  contentRef: RefObject<HTMLDivElement | null>;
  getContentWidth: () => number;
  getWindowWidth: () => number;
  minThumbWidth?: number;
  isAlwaysVisible?: boolean;
  keyboardStep?: number;
  className?: string;
  style?: CSSProperties;
  qaId?: string;
};

export const HorizontalScrollbar = ({
  scrollableContainerRef,
  contentRef,
  getContentWidth,
  getWindowWidth,
  minThumbWidth,
  isAlwaysVisible,
  keyboardStep,
  className,
  style,
  qaId
}: HorizontalScrollbarProps) => {
  const { containerProps, trackProps, thumbProps } = useHorizontalScrollbar({
    scrollableContainerRef,
    contentRef,
    getContentWidth,
    getWindowWidth,
    minThumbWidth,
    isAlwaysVisible,
    keyboardStep
  });

  return (
    <div {...containerProps} className={classNames(css.root, className)} style={style}>
      <div {...trackProps} className={css.scrollbarTrack} data-qa-id={qaId}>
        <div {...thumbProps} className={css.thumb} />
      </div>
    </div>
  );
};
